/**
 * Component to display list of dags in a tabular format.
 */
import React, { useEffect } from "react"
import { fetchDags } from "@/api/dags.api"
import { TableColumnsType } from "antd"
import useApi from "@/hooks/useapi"
import TableCustom from "@components/table"
import dayjs from "dayjs"
import DagSingle from "@pages/dags/dag"
import MetadataDags from "@pages/dags/metadata"

interface IDags {
  rules: any
  _id: string
  dagId: string
  title: string
  dateCreated: Date
  name: string
}

const DagsPage: React.FunctionComponent = () => {
  const { data, loading, error, request } = useApi(fetchDags)

  useEffect(() => {
    request()
  }, [])

  const columns: TableColumnsType<IDags> = [
    {
      title: "Id",
      dataIndex: "dagId",
      key: "dagId",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created at",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text: Date) => dayjs(text).format("DD/MM/YYYY - hh:mm:ss"),
    },
    {
      title: "Operation",
      render: (_, form) => (
        <div style={{ flexDirection: "row", display: "flex" }}>
          <DagSingle
            dagId={form._id}
            dagName={form.name}
            mode={"create"}
            schema={form.rules.variableSchema}
          />
          <DagSingle
            dagId={form._id}
            dagName={form.name}
            mode={"update"}
            schema={form.rules.variableSchema}
          />
          <MetadataDags dagId={form._id} />
        </div>
      ),
    },
  ]

  return (
    <div>
      <TableCustom
        size={"small"}
        rowKey={"_id"}
        loading={loading}
        dataSource={data?.dags}
        columns={columns}
      />
    </div>
  )
}

export default DagsPage
